import { render, staticRenderFns } from "./SuperAdminStudents.vue?vue&type=template&id=301a2bfa&"
import script from "./SuperAdminStudents.vue?vue&type=script&lang=js&"
export * from "./SuperAdminStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports